import $ from "jquery";
// JS
import './js/main.js'

//FA
import 'virtual-fontawesome-auto'


// SCSS
import './assets/tailwind/main.css'
